"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _MidPointInteractionHandler_drawingToolsManager, _MidPointInteractionHandler_geometryMathManager, _MidPointInteractionHandler_geometryState, _MidPointInteractionHandler_midPointInsertionActive, _MidPointInteractionHandler_midPointInsertionIndex;
Object.defineProperty(exports, "__esModule", { value: true });
exports.MidPointInteractionHandler = void 0;
const gl_matrix_1 = require("gl-matrix");
const IDrawingToolsManager_1 = require("../../../../interfaces/IDrawingToolsManager");
class MidPointInteractionHandler {
    // #endregion Properties (5)
    // #region Constructors (1)
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    constructor(drawingToolsManager, interactionManager) {
        // #region Properties (5)
        _MidPointInteractionHandler_drawingToolsManager.set(this, void 0);
        _MidPointInteractionHandler_geometryMathManager.set(this, void 0);
        _MidPointInteractionHandler_geometryState.set(this, void 0);
        _MidPointInteractionHandler_midPointInsertionActive.set(this, false);
        _MidPointInteractionHandler_midPointInsertionIndex.set(this, -1);
        __classPrivateFieldSet(this, _MidPointInteractionHandler_drawingToolsManager, drawingToolsManager, "f");
        __classPrivateFieldSet(this, _MidPointInteractionHandler_geometryState, drawingToolsManager.geometryState, "f");
        __classPrivateFieldSet(this, _MidPointInteractionHandler_geometryMathManager, drawingToolsManager.geometryMathManager, "f");
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get midPointInsertionActive() {
        return __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f");
    }
    get midPointInsertionIndex() {
        return __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f");
    }
    // #endregion Public Getters And Setters (2)
    // #region Public Methods (3)
    finishMidPointInsertion(distances) {
        if (__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f") === true) {
            if (distances) {
                // finish mid point insertion if it is the current index
                if (distances[0].index === __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f")) {
                    __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").makePointPersistent(__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f"), false);
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionActive, false, "f");
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionIndex, -1, "f");
                }
            }
        }
    }
    onMove(ray, hoveredPoint) {
        if (__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f") === true &&
            hoveredPoint === __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f")) {
            // we are just waiting for a mouse click to finish the mid point insertion
        }
        else if (hoveredPoint === undefined &&
            __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").canAddPoint()) {
            // check if there is a line close to the ray and add a mid point to it
            const lineDistances = __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryMathManager, "f").checkLineDistances(ray, __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").positionArray, __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").indicesArrayLines);
            if (lineDistances) {
                let firstIndex = lineDistances[0].index[0];
                let secondIndex = lineDistances[0].index[1];
                // Skip edges that already have an edge control defined
                const controls = __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").settings.controls;
                if (controls) {
                    const hasEdgeControl = controls.some((c) => c.type === "edge" &&
                        ((c.point1 === firstIndex &&
                            c.point2 === secondIndex) ||
                            (c.point1 === secondIndex &&
                                c.point2 === firstIndex)));
                    if (hasEdgeControl) {
                        this.stopMidPointInsertion();
                        return;
                    }
                }
                if (__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f") === true &&
                    firstIndex !== __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f") &&
                    secondIndex !== __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f")) {
                    // remove last added point
                    __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").removePointTemporary(__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f"));
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionActive, false, "f");
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionIndex, -1, "f");
                    // move indices one back if they are after the removal index
                    if (firstIndex > __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f")) {
                        firstIndex--;
                        if (firstIndex < 0)
                            firstIndex =
                                __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").getPointCount() - 1;
                    }
                    // move indices one back if they are after the removal index
                    if (secondIndex > __classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f") ||
                        secondIndex === 0) {
                        secondIndex--;
                        if (secondIndex < 0)
                            secondIndex =
                                __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").getPointCount() - 1;
                    }
                }
                if (__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f") === false) {
                    const firstPoint = __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").getPosition(firstIndex);
                    const secondPoint = __classPrivateFieldGet(this, _MidPointInteractionHandler_geometryState, "f").getPosition(secondIndex);
                    const midPoint = gl_matrix_1.vec3.add(gl_matrix_1.vec3.create(), firstPoint, secondPoint);
                    gl_matrix_1.vec3.scale(midPoint, midPoint, 0.5);
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionIndex, secondIndex, "f");
                    __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").addPointTemporary(secondIndex, midPoint);
                    __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").updateMaterialIndex(secondIndex, IDrawingToolsManager_1.MATERIAL_INDEX.INSERTION);
                    __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionActive, true, "f");
                }
            }
            else {
                this.stopMidPointInsertion();
            }
        }
        else {
            this.stopMidPointInsertion();
        }
    }
    stopMidPointInsertion() {
        if (__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionActive, "f") === true) {
            // remove last added point
            __classPrivateFieldGet(this, _MidPointInteractionHandler_drawingToolsManager, "f").removePointTemporary(__classPrivateFieldGet(this, _MidPointInteractionHandler_midPointInsertionIndex, "f"));
            __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionActive, false, "f");
            __classPrivateFieldSet(this, _MidPointInteractionHandler_midPointInsertionIndex, -1, "f");
        }
    }
}
exports.MidPointInteractionHandler = MidPointInteractionHandler;
_MidPointInteractionHandler_drawingToolsManager = new WeakMap(), _MidPointInteractionHandler_geometryMathManager = new WeakMap(), _MidPointInteractionHandler_geometryState = new WeakMap(), _MidPointInteractionHandler_midPointInsertionActive = new WeakMap(), _MidPointInteractionHandler_midPointInsertionIndex = new WeakMap();
//# sourceMappingURL=MidPointInteractionHandler.js.map